import { useState } from "react";
import RegenerateModal from "./RegenerateModal";

const BaseButton = ({
  imageSrc,
  altText,
  children,
  handleClick,
  className = "",
 isModalOpen: useModal = false,
  modalTitle = "Regenerate prompt",
  ...props
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageType, setCurrentImageType] = useState(null);

  const openRegenerateModal = (type) => {
    setCurrentImageType(type);
    setIsModalOpen(true);
  };

  const handleConfirm = (formData) => {
    if (handleClick && typeof handleClick === "function") {
      handleClick(formData);
    }
    setIsModalOpen(false);
  };
  
  
  

  const handleButtonClick = () => {
     if (useModal) {
       openRegenerateModal();
     } else if (handleClick) {
       handleClick();  
     }
  };
  

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  
  return (
    <>
      <button
        className={`btn d-inline-flex align-items-center ${className}`}
        onClick={handleButtonClick}
        {...props}
      >
        {imageSrc && (
          <img
            src={imageSrc}
            alt={altText}
            className="me-2"
            style={{ width: "20px", height: "20px", objectFit: "cover" }}
          />
        )}
        {children}
      </button>

      <RegenerateModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={(formData) => handleConfirm(formData)}   
      />

      <style jsx>{`
        .modal.show {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1050;
        }
        .input-group {
          position: relative;
        }
        .input-group .btn {
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          z-index: 3;
        }
        .input-group input {
          padding-right: 40px;
        }
      `}</style>
    </>
  );
};

export default BaseButton;